import { convertNumberToString, formatCurrency, removeNonNumericChars } from 'lib'
import { InputProps } from '../types'
import { CustomInput } from '../../../../ui/inputs/CustomInput'
import { Box } from 'ui/primitives'
import { absoluteBox, inputPadding } from './CurrencyInput.css'

export const CurrencyInput = ({ value, onChange, ...rest }: InputProps) => {
	const _onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		event.target.value = removeNonNumericChars(event.target.value)
		onChange && onChange(event)
	}

	const formattedValue = formatCurrency(convertNumberToString(value?.toString() || ''))

	return (
		<Box position="relative">
			<Box position="absolute" paddingRight="sm" paddingLeft="md" className={absoluteBox}>
				$
			</Box>
			<CustomInput
				{...rest}
				value={formattedValue}
				onChange={_onChange}
				// Because of absolute position of "$" element
				className={inputPadding}
				inputMode="numeric"
			/>
		</Box>
	)
}
